import "core-js/modules/es.array.push.js";
import { defineComponent } from 'vue';
import { mapState, useStore } from 'vuex';
import '../assets/css/empty.scss';
export default defineComponent({
  name: 'Empty',
  setup() {
    return {
      store: useStore()
    };
  },
  computed: {
    ...mapState(['taskType'])
  },
  methods: {
    handleAdd() {
      this.store.commit('update', {
        createFrom: 'create'
      });
      this.$stat({
        action: 'create_task_btn_click',
        data: {
          position: 'create'
        }
      });
      this.$router.push({
        path: '/upload/',
        query: this.$route.query
      });
    }
  }
});